import {z} from 'zod'
import {useTranslation} from '@/translations/i18n'
import {Controller, useFormContext} from 'react-hook-form'
import {MedicalReportFieldsSchema, REPORT_TEXTAREA_LIMIT} from '../../formSchemas'
import {MedicalReportTextArea} from '../medical-report-text-area/MedicalReportTextArea'

const HobbiesFieldSchema = MedicalReportFieldsSchema.pick({
    hobbiesNotes: true
})
type HobbiesFieldSchema = z.infer<typeof HobbiesFieldSchema>

export const HobbiesField = () => {
    const {t} = useTranslation()
    const form = useFormContext<HobbiesFieldSchema>()

    return (
        <Controller
            control={form.control}
            name="hobbiesNotes"
            render={({field, fieldState}) => (
                <MedicalReportTextArea
                    rows={4}
                    maxLength={REPORT_TEXTAREA_LIMIT}
                    currentField="hobbiesNotes"
                    title={t('medical_records:hobbies_notes')}
                    placeholder={t('commons:description_dot')}
                    errorMessage={fieldState.error?.message}
                    onChange={field.onChange}
                    value={field.value}
                />
            )}
        />
    )
}
